import Stack from '@mui/material/Stack';
import { FormikTextField } from '@shared/components/inputs/FormikTextField';
import { FormikSelectField } from '@shared/components/inputs/FormikSelectField';
import { PROVINCES_OPTIONS } from '@constants/leadCaptureConstants';
import type { StructuredAddressFieldsProps } from './ManualAddressEntry.types';

/**
 * The one structured address form in the codebase, lifted out of lead capture so
 * the manual-entry fallback reuses it rather than growing a second copy.
 *
 * Field names are the lead-capture names — including `state` for the province
 * select — so the lift needs no parameterisation and lead capture's own values,
 * schema and tests are untouched.
 */
export const StructuredAddressFields = <Values,>({ formik }: StructuredAddressFieldsProps<Values>) => (
  <>
    <Stack direction={{ xs: 'column' }} gap="15px" alignItems={{ xs: 'stretch' }}>
      <FormikTextField
        formik={formik}
        name="streetNumber"
        label="Street Number"
        className="lead-capture-text-input"
        containerSx={{ width: { xs: '100%' } }}
      />
      <FormikTextField
        formik={formik}
        name="unitNumber"
        label="Unit/Suite/Apartment Number"
        optional
        className="lead-capture-text-input"
        containerSx={{ width: { xs: '100%' } }}
      />
      <FormikTextField
        formik={formik}
        name="streetName"
        label="Street Name"
        className="lead-capture-text-input"
        containerSx={{ width: { xs: '100%' } }}
      />
    </Stack>
    <Stack direction={{ xs: 'column', md: 'row' }} gap="15px" alignItems={{ xs: 'stretch', md: 'flex-start' }}>
      <FormikTextField
        formik={formik}
        name="city"
        label="City"
        className="lead-capture-text-input"
        containerSx={{ width: { xs: '100%' } }}
      />
      <FormikSelectField
        formik={formik}
        name="state"
        label="Province/State"
        placeholder="Select a Province/State"
        options={PROVINCES_OPTIONS}
        storeOption
        containerSx={{ width: { xs: '100%' } }}
      />
      <FormikTextField
        formik={formik}
        name="postalCode"
        label="Postal/Zip Code"
        className="lead-capture-text-input"
        containerSx={{ width: { xs: '100%' } }}
      />
    </Stack>
  </>
);
